import React from "react";
import { CommandBarButton, CommandBarButtonMenuItem, useDisclosure } from "sprint-common-web";

import { DynamicSubtitleType } from "../../../../common/types/DynamicSubtitleType";
import { CopyCloudFileToUploadDialog } from "../../../../content-ingestion/cloud-files/common/components/copy-to-upload/CopyCloudFileToUploadDialog";
import { RequestCloudFileFixDialog } from "../../../../content-ingestion/cloud-files/common/components/request-cloud-fix/RequestCloudFileFixDialog";
import { isCloudSubtitleDetails, isInPreparation } from "../CloudAssetDetails";
import { useCloudAssetDetails } from "../common/hooks/useCloudAssetDetails";

export interface CloudAssetDetailsPageHeaderActionsProps {
    deliveryFileName: string;
    filePath: string;
    cloudFileId: string;
    cloudAssetId: string;
}

export const CloudAssetDetailsPageHeaderActions = ({
    deliveryFileName,
    filePath,
    cloudAssetId,
    cloudFileId
}: CloudAssetDetailsPageHeaderActionsProps): JSX.Element => {
    const { isOpen: isRequestFixOpen, onOpen: onRequestFixOpen, onClose: onRequestFixClose } = useDisclosure();
    const { isOpen: isCopyToUploadOpen, onOpen: onCopyToUploadOpen, onClose: onCopyToUploadClose } = useDisclosure();
    const { data: assetDetails } = useCloudAssetDetails();

    const menuItems: CommandBarButtonMenuItem[] = [
        {
            text: "Request fix",
            icon: "ProcessMetaTask",
            onClick: onRequestFixOpen,
            disabled: assetDetails && isInPreparation(assetDetails)
        },
        {
            text: "Copy to upload",
            icon: "Copy",
            onClick: onCopyToUploadOpen,
            disabled:
                assetDetails &&
                (isInPreparation(assetDetails) ||
                    (isCloudSubtitleDetails(assetDetails) &&
                        assetDetails.subtitleType === DynamicSubtitleType.Dvb &&
                        assetDetails.sourceSubtitleType !== DynamicSubtitleType.Dvb))
        }
    ];

    return (
        <>
            <CommandBarButton icon="MoreVertical" testId="asset-details-header-actions" menuItems={menuItems} />
            <RequestCloudFileFixDialog
                deliveryFileName={deliveryFileName}
                filePath={filePath}
                isOpen={isRequestFixOpen}
                cloudFileId={cloudFileId}
                cloudAssetId={cloudAssetId}
                onClose={onRequestFixClose}
            />
            <CopyCloudFileToUploadDialog
                cloudAssetId={cloudAssetId}
                isOpen={isCopyToUploadOpen}
                onClose={onCopyToUploadClose}
            />
        </>
    );
};
